<!--
 * @Author: yannis yannis2473@163.com
 * @Date: 2025-04-14 15:20:21
 * @LastEditors: yannis yannis2473@163.com
 * @LastEditTime: 2025-07-08 10:02:15
 * @FilePath: \crm-admin-vue\src\views\layout\components\Sidebar\Item.vue
 * @Description: Do not edit
 * Copyright (c) 2025 by 久雀商业/Yannis, All Rights Reserved. 
-->
<template>
  <div :class="{ 'is-close': collapse }" class="menu-item-content">
    <i v-if="icon && icon.startsWith('icon')" :class="['iconfont', `${icon}`]"></i>
    <i v-else :class="['wk', `wk-${icon}`]" />
    <span class="side-bar-label">{{ title }}</span>
    <span v-if="count">({{ count }})666</span>
    <el-badge v-if="num && num > 0" :max="99" :value="num" />
  </div>
</template>

<script>
export default {
  name: 'Item',
  components: {},
  props: {
    icon: String,
    title: String,
    num: [String, Number],
    collapse: Boolean,
    count: [String, Number]
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},

  beforeDestroy() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.menu-item-content {
  width: 100%;
  border-radius: $xr-border-radius-base;
  line-height: 36px;
  margin: 5px 0;
  padding-left: 10px;
  position: relative;
  cursor: pointer;
}

.menu-item-content.is-close {
  .el-badge {
    position: absolute;
    top: 6px;
    left: 50%;
    right: auto;
    transform: translateX(-50%);
  }

  .side-bar-label {
    opacity: 0;
  }
}

.wk,
.iconfont {
  margin-right: 8px;
}

.side-bar-label {
  opacity: 1;
  transition: transform 0.3s;
}

// 消息数
.el-badge {
  position: absolute;
  right: 4px;
  top: 6px;
  /deep/ .el-badge__content {
    border-width: 0;
  }
}
</style>
